import styled from "styled-components";
import color from "../../assets/css/colors";

export const Container = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-top: 50px;
    margin-bottom: 20px;
`;

export const Card = styled.div`
    width: 300px;
    margin-right: 20px;
    padding-top: 23px;
    padding-left: 31px;
    padding-right: 12px;
    padding-bottom: 39px;
    background: ${color.grayLight} 0% 0% no-repeat padding-box;
    border-radius: 10px;
`;

export const CardPlanNameAndStatusContainer = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: 14px;
`

export const CardPlanName = styled.h2`
    font: normal normal normal 15px/21px Circular Std Book;
    color: ${color.primary};
    margin-bottom: 0px;
    margin-right: 4px;
`;

export const CardPlanStatus = styled.span`
    font: normal normal normal 10px Circular Std Book;
    color: ${color.grayDark};
`;

export const CardPlanDescription = styled.h3`
    font: normal normal normal 12px Circular Std Book;
    letter-spacing: 0px;
    color: ${color.grayDark};
    margin-bottom: 31px;
`;

export const CardPaymentOptionsContainer = styled.div`
    margin: 15px 0;
`;

export const CardPaymentOptionsTitleRow = styled.div`
    display: flex;
    align-items: center;
`;

export const CardPaymentOptionsTitle = styled.h2`
    width: 80px;
    height: 14px;
    font: normal normal 600 14px Muli;
    letter-spacing: 0.7px;
    color: ${color.tertiary};
    margin-bottom: 0px;
`;

export const CardPaymentOptionsDetail = styled.div`
    height: 14px;
    display: flex;
    align-items: center;
    font: normal normal 600 10px Muli;
    letter-spacing: 0.5px;
    color: ${color.primary};
    cursor: pointer;
`;

export const CardPaymentOptionsDetailDescription = styled.p`
    margin-top: 7px;
    margin-bottom: 7px;
    font: normal normal normal 12px Circular Std Book;
    color: ${color.grayDark};
`;

export const TableContainer = styled.div`
    width: 100%;
    background: ${color.white} 0% 0% no-repeat padding-box;
    border-radius: 5px;
    padding: 14px 18px 25px 13px;
    margin-bottom: 27px;
    max-height: 300px;
    overflow: auto;

    &::-webkit-scrollbar {
        width: 12px;
    }

    &::-webkit-scrollbar-track {
        background: ${color.scrollBarBackground};
    }

    &::-webkit-scrollbar-thumb {
        background-color: ${color.scrollBarThumb};
        border-radius: 20px;
        border: 3px solid ${color.scrollBarBackground};
    }
`;

export const Thead = styled.thead`
    border-bottom: 2px solid ${color.tertiary};
`;

export const TH = styled.th`
    font: normal normal normal 12px Circular Std Book;
    color: ${color.tertiary};
`;

export const TD = styled.td`
    font: normal normal normal 12px Circular Std Book;
    color: ${color.grayDark};
    padding-top: 10px;
`;